import { useOnSurfaceNodeSave } from 'components/canvas/hooks/use-on-surface-node-save';
import useMutation from 'hooks/use-mutation';
import { createSurfaceBackgroundNodeMutation } from 'graphql/surface-node/mutations/surface-background-node/create-surface-background-node';
import { updateSurfaceBackgroundNodeMutation } from 'graphql/surface-node/mutations/surface-background-node/update-surface-background-node';
import { pick } from 'lodash';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';

export default function useSaveSurfaceBackgroundNode(surfaceId: string) {
  const onSurfaceBackgroundNodeCreate = useOnSurfaceNodeSave(
    'createSurfaceBackgroundNode',
  );

  const onSurfaceBackgroundNodeUpdate = useOnSurfaceNodeSave(
    'updateSurfaceBackgroundNode',
  );

  const [createSurfaceBackgroundNode] = useMutation(createSurfaceBackgroundNodeMutation, {
    update: onSurfaceBackgroundNodeCreate as any,
  });

  const [updateSurfaceBackgroundNode] = useMutation(updateSurfaceBackgroundNodeMutation, {
    update: onSurfaceBackgroundNodeUpdate as any,
  });

  return function saveSurfaceBackgroundNode(params) {
    const isUpdate = params.variables.input.id;

    if (isUpdate) {
      params.variables.input = pick(params.variables.input, [
        'id',
        'name',
        'url',
        'format',
        'isFixed',
        'size'
      ]);

      return updateSurfaceBackgroundNode(params);
    }
    params.variables.input = pick(params.variables.input, [
      'surface',
      'name',
      'url',
      'format',
      'position',
      'size'
    ]);

    return createSurfaceBackgroundNode(params);
  };
}
